import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { OemService } from 'src/app/services/oem/oem.service';
import { SweetAlertService } from 'src/app/services/sweetalert.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-brand-contact-us',
  templateUrl: './brand-contact-us.component.html',
  styleUrls: ['./brand-contact-us.component.scss']
})

export class BrandContactUsComponent implements OnInit {
  @Input() data : any;
  enquiryForm!: FormGroup;
  submitted = false;
  isEmailError: boolean = false;
  brandId : string = '';
  brandName : string = '';
  logo : string = '';
  url : string = '';
  userId : string = '';
  countryCodes: any[] = [];
  filteredCountryCodes: any[] = [];
  searchControl = new FormControl('');
  showDropdown: boolean = false;
  senderId: string = '';
  safeUrl!: SafeResourceUrl;
  truncatedAddress: string = '';
  showFull: boolean = false;
  ipadViewForPhoneField: boolean = false;
  isLoggedIn: boolean = true;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute, 
    private oemService : OemService,
    private sweetAlertService : SweetAlertService,
    private localStorageService: LocalStorageService,
    private authService : AuthService,
    private domSanitizier: DomSanitizer,
    private breakpointObserver: BreakpointObserver,
    private router: Router
  ) {
    this.enquiryForm = this.fb.group({
      name: ['', [Validators.required, noWhitespaceValidator(), Validators.pattern('^[a-zA-Z ]*$')]],  
      email: ['', [Validators.required, Validators.email,]],
      countryCode: ['', [Validators.required]],
      phoneCode : [''],
      phone: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(5), Validators.maxLength(15)]],
      message: ['']
    }); 
   }

  ngOnInit(): void {
    this.ShowItemsBasedonScreenSize();
    this.isUserLoggedIn();
    if(this.data.address && this.data.address.length > 0){
      this.truncatedAddress = this.data.address.length > 70 ? this.data.address.slice(0, 70) + '...' : this.data.address;
    }
    this.route.queryParams.subscribe(params => {
      if (params !== undefined && params !== null && Object.entries(params).length > 0) {
        
        this.brandId = params['brandId'];
        this.brandName = params['brandName'];
        this.logo = params['logo'];
        this.url = params['url'];
      }
    });

    this.localStorageService.getUserDetails().subscribe(data=>{
      this.userId=data?.userId ? data?.userId: '';
      this.senderId = this.userId;
    })
    if(this.localStorageService.getItem('roleName') === 'DISTRIBUTOR') {
      this.senderId = this.localStorageService.getItem('distributorId');
    }
    else if(this.localStorageService.getItem('roleName') === 'OEM'){
      this.senderId = this.localStorageService.getItem('oemId');
    }

    this.getCountryCodes();

    this.searchControl.valueChanges.subscribe((term) => {
      this.filterCountryCodes(term ?? '');
    });

    const addressUrl = `https://maps.google.com/maps?q=${encodeURIComponent(this.data.address)}&output=embed`;
    this.safeUrl = this.domSanitizier.bypassSecurityTrustResourceUrl(addressUrl);
  }
  toggleView(): void {
    this.showFull = !this.showFull;
  }
filterCountryCodes(term: string): void {
  this.filteredCountryCodes = term ? 
    this.countryCodes.filter(code =>
      code.countryCode.toLowerCase().includes(term.toLowerCase())
    ) 
    : this.countryCodes; 
}

selectCountryCode(code: { countryCode: string; phoneCode: string }): void {
  this.enquiryForm.patchValue({
    countryCode: code.countryCode,
    phoneCode: code.phoneCode
  });
  this.searchControl.setValue(code.countryCode);
  this.showDropdown = false;
}

showDropdownList(): void {
  // Reset the filtered list to show all country codes
  this.filteredCountryCodes = this.countryCodes;
  this.showDropdown = true;
}

// Hide dropdown list with a delay
hideDropdown(): void {
  setTimeout(() => this.showDropdown = false, 200);
}


  getCountryCodes(): void { 
    this.authService.getCountrycodes(0, 300).subscribe(
      (response) => {
        this.countryCodes = response.data;
        this.filteredCountryCodes = this.countryCodes;
      
        
      },
      (error) => {
      
      }
    );
  }

  updatePhoneCode(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const selectedCountryCode = selectElement.value;
   
    
    const selectedCode = this.countryCodes.find(code => code.countryCode === selectedCountryCode);
    if (selectedCode) {
      this.enquiryForm.patchValue({
        phoneCode: selectedCode.phoneCode
      });
    }
  }

  onSubmit(): void {
    this.submitted = true;    
    if (!this.userId) {
      this.sweetAlertService.showWarning('', 'Login required before sending enquiry!');
      return;
    }

    if (this.enquiryForm.invalid) {
      this.sweetAlertService.showWarning('', 'Please fill all the required fields');    
      return;
    }

    if (this.enquiryForm.valid) {
      const formData = this.enquiryForm.value;
      const payload = {
        senderId: this.senderId,
        enqCustomerName: formData.name,
        email: formData.email,
        phone: this.concatCountryCodeAndPhone(),
        message: formData.message,
        receiverId: [this.senderId, this.data.id],
        enquiryType: 'GENERAL',
        isGroup : true
      };
     

      this.oemService.saveEnquiry(payload).subscribe(
        (response) => {
          this.sweetAlertService.showSuccess('', 'Enquiry submitted successfully !!');
          this.enquiryForm.reset();
          this.searchControl.setValue(''); 
          this.showDropdown = false; 
        },
        (error) => {
         
          this.sweetAlertService.showError('', 'Failed to submit enquiry !!');
        }
      );
    } else {
      this.enquiryForm.markAllAsTouched();
     
    }
  }

  concatCountryCodeAndPhone(): string {
    const phoneCode = this.enquiryForm.get('phoneCode')?.value || '';
   
    
    const phone = this.enquiryForm.get('phone')?.value || '';
    return `${phoneCode}${phone}`;
  }

  get f() { return this.enquiryForm.controls; }
  get phone() {
    return this.enquiryForm.get('phone');
  }

  get isPhoneInvalid() {
    return this.enquiryForm.get('phone')?.invalid && (this.enquiryForm.get('phone')?.dirty || this.enquiryForm.get('phone')?.touched);
  }

  get isNameInvalid() {
    return this.enquiryForm.get('name')?.invalid && (this.enquiryForm.get('name')?.dirty || this.enquiryForm.get('name')?.touched);
  }

  get isEmailInvalid() {
    if (this.submitted) {
        if(!this.enquiryForm.get('email')?.value){ 
          this.isEmailError = true;
        } else {
          this.isEmailError = false;
        }
      return this.enquiryForm.get('email')?.invalid;
    }
    return (this.enquiryForm.get('email')?.dirty || this.enquiryForm.get('email')?.touched);
  }

  onCancel(): void {
    this.enquiryForm.reset();
  }

  sanitizeUrl(url: string): void {
    if (!url) {
      return;
    }
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  ShowItemsBasedonScreenSize() {
    this.breakpointObserver.observe([
      '(min-width: 1190px) and (max-width: 1390px)'
    ]).subscribe(result => {
      if (result.matches) {
        if (result.breakpoints['(min-width: 1190px) and (max-width: 1390px)']) {
          this.ipadViewForPhoneField = true
        }
      } else {
        this.ipadViewForPhoneField = false
      }
    });
  }
  isUserLoggedIn() {
    if(this.authService.isAuthenticated() === false) {
      this.isLoggedIn = false;
    }
  }

  onLoginPage() {
    this.router.navigate(['/login']);
  }
}


export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  };
}
